import { useContext, useEffect, useState } from "react";
import { Context } from "..";
import AssociacionsAPI from "../API/AssociationsAPI";
import PrimaryAPI from "../API/PrimaryAPI";

const showLogs = true;
const usePrimary = (isMe, isInner, docsCount, timeLimit, responsibleId) => {

    const { store } = useContext(Context);
    const [params, setParams] = useState(null);
    const [hourCost, setHourCost] = useState(0);
    const [currDiscount, setCurrDiscount] = useState(0);

    const [primarySumm, setSumm]  = useState(0);

    useEffect(() => {
        loadHourCost().then(() => showLogs && console.log("[✓] Стоимость часа по первичке загружена"));
        loadParams().then(() => showLogs && console.log("[✓] Параметры первички загружены"));
    }, []);
    useEffect(() => {
        if (!params) return;
        setSumm(mathSumm());
    }, [params, hourCost, isMe, isInner, docsCount, timeLimit, currDiscount]);

    const loadHourCost = async () => {
        try {
            const association = await AssociacionsAPI.getAll();
            const result = await store.getPositionInfo(responsibleId ? responsibleId : association.data.primary_id);
            if (result.error === true) throw result;

            setCurrDiscount(result.response ? result.response.discount : 0);
            setHourCost(result.response ? result.response.hoursCost : 0);
        } catch (err) {
            showLogs && console.log("[x] Ошибка в расчетах стоимости часа первичника:", err);
            setHourCost(0);
        }
    }
    const loadParams = async () => {
        try {
            const response = await PrimaryAPI.getAll();
            if (response.status !== 200) throw response;
            if (!response.data) return;

            setParams(response.data);
        } catch (err) {
            showLogs && console.log("[x] Ошибка получения параметров первички:", err);
        }
    }

    const mathSumm = () => {
        try {
            let summ = 0;
            let timeDoc = params[isInner?"inner":"outer"][isMe?"me":"client"].time_doc;
            let timeLine = params[isInner?"inner":"outer"][isMe?"me":"client"].time_line;
            if (isMe) summ = ((docsCount * timeDoc) + (timeLimit * timeLine * docsCount)) * (hourCost / 60);
            else summ = docsCount * timeDoc * (hourCost / 60);

            return Math.ceil(summ);
        } catch (err) {
            showLogs && console.log("[x] Ошибка вычисления в разделе первички:", err);
            return 0;
        }
    }

    return {
        pr_summ: primarySumm,
        pr_hourCost: hourCost,
        pr_changeDiscount: async (newDiscount) => {
            if (newDiscount == undefined) return;
            if (newDiscount == currDiscount) return;
            await loadHourCost();
            setCurrDiscount(newDiscount);
        },
        pr_changeParams: async () => {
            await loadParams();
            setSumm(mathSumm());
        },
        pr_changeAssociation: async () => {
            await loadHourCost();
        }
    }
}

export default usePrimary;
